import { getHeadersFiles } from "./middleware";
import { handleServiceError } from "./errorHandler";
import { REACT_APP_API_PAYMENT } from "../config";
import { sentryFetch } from "./sentryApiWrapper";

const BASE_URL = REACT_APP_API_PAYMENT;

export interface PaymentSessionRequest {
    action: string;
    showOmitPayment: boolean;
    language: string;
    IDQuotation: string;
    IDApplication: string;
    IDPerson: string;
    plan: string;
    typePerson: string;
    frequency: string;
    amount: number;
    currency: string;
    term: number;
    automaticApproval: boolean;
    redirectUrl: string;
    formData: {
        firstName: string;
        lastName: string;
        middleName: string;
        email: string;
        phone: string;
        address: string;
        city: string;
        state: string;
        country: string;
        zipCode?: string;
    };
}

export interface PaymentSessionResponse {
    sessionID?: string;
    message?: string;
}

export const createInitialPaymentSession = (): PaymentSessionRequest => {
    return {
        action: "pay",
        showOmitPayment: true,
        language: "ES",
        IDQuotation: "",
        IDApplication: "",
        IDPerson: "",
        plan: "",
        typePerson: "",
        frequency: "",
        amount: 0,
        currency: "USD",
        term: 0,
        automaticApproval: true,
        redirectUrl: window.location.href,
        formData: {
            firstName: "",
            lastName: "",
            middleName: "",
            email: "",
            phone: "",
            address: "",
            city: "",
            state: "",
            country: "",
            zipCode: ""
        }
    };
};

export const createPaymentSession = async (request: PaymentSessionRequest): Promise<PaymentSessionResponse> => {
    try {
        const response = await sentryFetch(
            `${BASE_URL}session`,
            {
                method: 'POST',
                headers: getHeadersFiles(),
                body: JSON.stringify(request),
            },
            {
                operation: 'create_payment_session',
                IDQuotation: request.IDQuotation,
                IDApplication: request.IDApplication,
                amount: request.amount,
                currency: request.currency,
                plan: request.plan
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error: ${response.status} - ${errorData.message}`);
        }

        return await response.json() as PaymentSessionResponse;
    } catch (error) {
        handleServiceError(error);
        throw error;
    }
};